

















import store from "@/store";
import Vue from "vue";

export default Vue.extend({
  name: "LoadingScreen",
  computed: {
    loadingText: (): string => {
      return store.state.loadingSettings.loadingText;
    }
  }
});
